import { attr, BaseModel } from "../../lib/itn-ui-kit/data";

export default class CaseInjuriesGraphModel extends BaseModel {
  @attr("array") dates;
  @attr("array") general;
  @attr("array") injuryData;
}
